import { Box, Spinner } from '@veracity/vui'

export const PageLoader = () => (
  <Box center w="100%" h={300}>
    <Spinner />
  </Box>
)
